import { render, staticRenderFns } from "./SubBlockEdit.vue?vue&type=template&id=7841bf28&scoped=true"
import script from "./SubBlockEdit.vue?vue&type=script&lang=js"
export * from "./SubBlockEdit.vue?vue&type=script&lang=js"
import style0 from "./SubBlockEdit.vue?vue&type=style&index=0&id=7841bf28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7841bf28",
  null
  
)

export default component.exports